let state = {
  
    infoGrade: '',
    disciplinaGrade:''


}

export default state